import { useState } from "react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

export default function Contacts() {
  const [copied, setCopied] = useState(false);

  return (
    <main
      className="flex-1 flex items-center justify-center px-6 md:px-12"
      data-testid="contacts-page"
    >
      <Seo
        title="Contacts — TRONA"
        siteName="TRONA"
        description="Book TRONA: booking@tronamusic.com"
      />
      <Reveal>
        <h1 className="m-0 text-center">
          <a
            href="mailto:booking@tronamusic.com"
            data-testid="booking-email-link"
            onClick={() => {
              try {
                navigator.clipboard
                  ?.writeText("booking@tronamusic.com")
                  .then(() => {
                    setCopied(true);
                    window.setTimeout(() => setCopied(false), 1600);
                  })
                  .catch(() => {});
              } catch {
                /* clipboard unavailable — mailto still opens */
              }
            }}
            className="font-display uppercase leading-none tracking-tight text-[8.5vw] sm:text-6xl lg:text-8xl text-[#1A1512] hover:text-[#504439] transition-colors duration-150 break-all cursor-pointer"
          >
            booking@tronamusic.com
          </a>
        </h1>
        <p
          aria-live="polite"
          data-testid="email-copied-feedback"
          className={`mt-6 text-center font-mono text-[10px] tracking-[0.25em] uppercase text-[#504439] transition-opacity duration-150 ${
            copied ? "opacity-100" : "opacity-0"
          }`}
        >
          Copied to clipboard
        </p>
      </Reveal>
    </main>
  );
}
